/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkPackageStatusDtoPage } from '../../models/work-package-status-dto-page';

export interface ListWorkPackageStatuses$Params {
  query?: string;
  isActive?: boolean | null;
  tenantId?: string | null;
  offset?: number;
  limit?: number;
  sorting?: Array<'id' | '-id' | 'tenantId' | '-tenantId' | 'name' | '-name' | 'isDefault' | '-isDefault' | 'isActive' | '-isActive' | 'isWorkPackageClosed' | '-isWorkPackageClosed' | 'isWorkPackageInProgress' | '-isWorkPackageInProgress' | 'isWorkPackageReadonly' | '-isWorkPackageReadonly' | 'position' | '-position' | 'color' | '-color' | 'icon' | '-icon' | 'createdAt' | '-createdAt' | 'updatedAt' | '-updatedAt'>;
}

export function listWorkPackageStatuses(http: HttpClient, rootUrl: string, params?: ListWorkPackageStatuses$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkPackageStatusDtoPage>> {
  const rb = new RequestBuilder(rootUrl, listWorkPackageStatuses.PATH, 'get');
  if (params) {
    rb.query('query', params.query, {});
    rb.query('isActive', params.isActive, {});
    rb.query('tenantId', params.tenantId, {});
    rb.query('offset', params.offset, {});
    rb.query('limit', params.limit, {});
    rb.query('sorting', params.sorting, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkPackageStatusDtoPage>;
    })
  );
}

listWorkPackageStatuses.PATH = '/v0/workPackageStatuses';
